import { render } from "./HotSpotList.vue?vue&type=template&id=0b04f56c&scoped=true"
import script from "./HotSpotList.vue?vue&type=script&lang=js"
export * from "./HotSpotList.vue?vue&type=script&lang=js"

import "./HotSpotList.vue?vue&type=style&index=0&id=0b04f56c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b04f56c"]])

export default __exports__